import * as _ from 'lodash';

import { PayslipCollection } from "../../payroll/PayslipCollection";
import { PaymentLock } from '../../payroll/PaymentLock';

/**
 * @typedef { import('../../payroll/PayslipModel').PayslipModel } PayslipModel
 */

angular.module("tromanWeb").controller('PayrollController', ['$q', 'stateService', 'tromanServer', 'ObjectCache', 'dialogService', 'tromanGlobals', 'meetingShared', function ($qservice, stateService, tromanServer, ObjectCache, dialogService, tromanGlobals, meetingShared) {

    this.isSaving = false;
    this.paymentLock = new PaymentLock();
    this.selectionCount = 0;

    /** @type {PayslipCollection} */
    this.collection = null;
    this.IsWarningMissingMeetingPaymentEnabled = tromanGlobals.systemInfo.IsWarningMissingMeetingPaymentEnabled;

    this.$onInit = function $onInit() {
        $qservice
            .all({
                payslips: tromanServer.Payroll.getMeetingPayroll(meetingShared.meeting.Id),
                wageTypes: ObjectCache.getWageTypes(null, {
                    Archived: 1,
                    ValidAt: meetingShared.meeting.Date
                }),
                wageCalculations: ObjectCache.getWageCalculations(meetingShared.meeting.WageCalculation),
                politikerSettings: tromanServer.Politiker.getSettings(),
            })
            .then(result => {
                this.paymentLock.reset();

                this.wageCalculations = result.wageCalculations;
                this.selectedCalculation = _.find(result.wageCalculations, x => x.Id === meetingShared.meeting.WageCalculationId);

                this.collection = new PayslipCollection(meetingShared.meeting, result.payslips, result.politikerSettings, this.selectedCalculation);

                this.isMissingWageGroup = !meetingShared.meeting.Organization.WageGroup;

                let usedWageTypes = new Set();
                result.payslips.forEach(ps => ps.Remunerations.forEach(rem => rem.Payments.forEach(y => usedWageTypes.add(y.WageTypeId))));

                this.wageTypes = result.wageTypes.filter(x => x.Active || usedWageTypes.has(x.Id));

                // The childforms will propagate $dirty to parentForm, but that value is not reset after they are removed.
                // There is no good place to reset parentForm without being "hacky".
                // Check children directly instead (children.length should be 0 or 1)
                stateService.guard(() => this.collection.hasChanges || _.some(this.parentForm?.$getControls(), x => x.$dirty));
            })
            .catch(dialogService.error);
    };

    this.canFilter = function canFilter() {
        return !this.paymentLock.isLocked;
    };

    /**
     * @param {PayslipModel} payslipModel
     */
    this.payslipVisible = function payslipVisible(payslipModel) {
        switch (this.filter) {
            case 'txissue': return payslipModel.hasTransactionIssues;
            case 'warning': return payslipModel.hasWarnings;
            case 'missingmeeting': return payslipModel.isMissingMeetingPayment;
            case 'missingcertifier': return payslipModel.isMissingCertifier;
            case 'newclaim': return payslipModel.hasPolitikerTasks;
            case 'certrejected': return payslipModel.hasRejectedCertification;
            case 'certrecalled': return payslipModel.hasRecalledCertification;
            default: return true;
        }
    };

    this.selectionChanged = function () {
        this.selectionCount = this.collection.countSelectedPayments();
    };

    this.canCalculate = function () {
        if (this.selectedCalculation == null) return false;
        if (this.paymentLock.isLocked) return false;
        return true;
    };

    this.calculate = function () {
        if (!this.canCalculate()) return;

        try {
            this.collection.calculate(this.selectedCalculation, x => this.payslipVisible(x));
            if (this.filter === 'missingmeeting') {
                this.filter = '';
            }
        } catch (err) {
            dialogService.error(err);
        }
    };

    this.canApproveAllPolitiker = function () {
        return this.collection != null && this.collection.hasAnyPolitikerTasks;
    };

    this.approveAllPolitiker = function () {
        if (!this.canApproveAllPolitiker()) return;

        this.collection?.approveAllPolitiker();
        this.filter = '';
    };

    this.canRemoveSelected = function () {
        if (this.paymentLock.isLocked) return false;
        if (this.selectionCount === 0) return false;
        return true;
    };

    this.removeSelected = function () {
        if (!this.canRemoveSelected()) return;

        this.collection.removeSelectedPayments();
    };

    this.canSave = function () {
        if (this.paymentLock.isLocked) return false;
        if (this.isSaving) return false;
        if (this.collection == null) return false;
        if (!this.collection.hasChanges) return false;
        if (!this.parentForm) return false;
        if (this.parentForm.$invalid) return false;

        return true;
    };

    this.save = function () {
        if (!this.canSave()) return;

        let cmd = this.collection.createUpdate();

        this.isSaving = true;
        tromanServer.Payroll.updateMeetingPayroll(meetingShared.meeting.Id, cmd)
            .finally(() => this.isSaving = false)
            .then(() => {
                stateService.forceReload('meeting');
            })
            .catch(dialogService.error);
    };
}]);
